export default __webpack_public_path__ + "static/media/sld.22ec7d25.png";